import React from "react";
import {
  HomeIcon,
  BuildingOffice2Icon,
  SparklesIcon,
  ShieldCheckIcon,
  GlobeAltIcon,   // ✅ replaced LeafIcon with GlobeAltIcon
  ClockIcon,
} from "@heroicons/react/24/solid";
import Meta from "../components/Meta";
import { Link } from "react-router-dom";

export default function Services() {
  return (
    <section id="services" className="px-6 md:px-16 py-20 bg-gray-50">
      {/* Title */}
      <div className="text-center mb-14">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
          Nos services de nettoyage
        </h2>
        <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
          Des solutions de nettoyage professionnelles adaptées à vos besoins. 
          De l'entretien régulier au nettoyage en profondeur, nous avons tout ce qu'il vous faut.
        </p>
      </div>
       <Meta
          title="Cleaning Services in Paris: Office, Housekeeping, Windows, Post-Construction | PJG Service"
          description="Cleaning for businesses and homes across Paris & Île-de-France: office cleaning, housekeeping, window washing, and post-construction cleanup. Fast quotes."
          path="/services"
          primaryDomain="https://pjgservice.com"
          locale="en"
          alternates={[
            { hrefLang: "en",    href: "https://pjgservice.com/services" },
            { hrefLang: "fr-FR", href: "https://pjgservice.fr/services" },
            { hrefLang: "x-default", href: "https://pjgservice.fr/services" }
          ]}
          breadcrumbs={[
            { name: "Home", url: "/" },
            { name: "Services", url: "/services" }
          ]}
        />



      {/* Service Cards */}
      <div className="grid gap-8 md:grid-cols-3">
        {/* Residential Cleaning */}
        <div className="bg-white rounded-lg p-6 border-2 border-gray-400 hover:border-blue-900 hover:shadow-xl transition">
          <div className="flex items-center justify-center w-12 h-12 bg-blue-900 text-white rounded-md mb-4">
            <HomeIcon className="w-6 h-6" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">
            Nettoyage résidentiel
          </h3>
          <p className="text-gray-600 mt-2">
            Services complets de nettoyage à domicile, y compris les cuisines, les salles de bains,
            les chambres et les espaces de vie.
          </p>
          <ul className="list-disc list-inside text-gray-600 mt-4 space-y-1">
            <li>Nettoyage en profondeur</li>
            <li>Entretien régulier</li>
            <li>Nettoyage avant/après déménagement</li>
          </ul>
          <p className="mt-6 font-semibold text-gray-900">À partir de 80 €</p>
          <Link
            to="/contact#contact"
            className="mt-4 w-full bg-blue-900 text-white py-2 rounded-md hover:bg-blue-800 inline-block text-center"
          >
            Réserver le service
          </Link>
        </div>

        {/* Commercial Cleaning */}
        <div className="bg-white rounded-lg p-6 border-2 border-gray-400 hover:border-blue-900 hover:shadow-xl transition">
          <div className="flex items-center justify-center w-12 h-12 bg-blue-900 text-white rounded-md mb-4">
            <BuildingOffice2Icon className="w-6 h-6" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">
            Nettoyage commercial
          </h3>
          <p className="text-gray-600 mt-2">
            Nettoyage professionnel des bureaux et des espaces commerciaux pour les entreprises de toutes tailles.
          </p>
          <ul className="list-disc list-inside text-gray-600 mt-4 space-y-1">
            <li>Nettoyage de bureaux</li>
            <li>Espaces de vente au détail</li>
            <li>Établissements médicaux</li>
          </ul>
          <p className="mt-6 font-semibold text-gray-900">À partir de 120 €</p>
          <Link
            to="/contact#contact"
            className="mt-4 w-full bg-blue-900 text-white py-2 rounded-md hover:bg-blue-800 inline-block text-center"
          >
            Réserver le service
          </Link>
        </div>

        {/* Deep Cleaning */}
        <div className="bg-white rounded-lg p-6 border-2 border-gray-400 hover:border-blue-900 hover:shadow-xl transition">
          <div className="flex items-center justify-center w-12 h-12 bg-blue-900 text-white rounded-md mb-4">
            <SparklesIcon className="w-6 h-6" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">Nettoyage en profondeur</h3>
          <p className="text-gray-600 mt-2">
            Service de nettoyage intensif pour les espaces nécessitant une attention et un soin particuliers.
          </p>
          <ul className="list-disc list-inside text-gray-600 mt-4 space-y-1">
            <li>Post-construction</li>
            <li>Nettoyage de printemps</li>
            <li>Service ponctuel</li>
          </ul>
          <p className="mt-6 font-semibold text-gray-900">À partir de 150 €</p>
          <Link
            to="/contact#contact"
            className="mt-4 w-full bg-blue-900 text-white py-2 rounded-md hover:bg-blue-800 inline-block text-center"
          >
            Réserver le service
          </Link>
        </div>
      </div>

      {/* Features Section */}
      <div className="grid md:grid-cols-3 gap-8 mt-20 text-center">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-blue-900 mb-4">
            <ShieldCheckIcon className="w-7 h-7" />
          </div>
          <h4 className="font-semibold text-gray-900">Assuré et cautionné</h4>
          <p className="text-gray-600 text-sm mt-2">
            Couverture d'assurance complète pour votre tranquillité d'esprit
          </p>
        </div>

        <div className="flex flex-col items-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-blue-900 mb-4">
            <GlobeAltIcon className="w-7 h-7" />   {/* ✅ replaced LeafIcon */}
          </div>
          <h4 className="font-semibold text-gray-900">Écologique</h4>
          <p className="text-gray-600 text-sm mt-2">
            Produits de nettoyage sûrs et non toxiques
          </p>
        </div>

        <div className="flex flex-col items-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-blue-900 mb-4">
            <ClockIcon className="w-7 h-7" />
          </div>
          <h4 className="font-semibold text-gray-900">Horaires flexibles</h4>
          <p className="text-gray-600 text-sm mt-2">
            Disponible 7 jours sur 7
          </p>
        </div>
      </div>
    </section>
  );
}